import { graphlib, layout } from "dagre";
import { Node, Edge, Position } from "@xyflow/react";
import { ZAP_STEP_NODE_HEIGHT } from "@zapier/canvas-constants";
import { ZapNodeData, ZapStepNodeData } from "../types";

type Params = {
  zapNode: Node<ZapNodeData>;
  zapSteps: Node<ZapStepNodeData>[];
  zapStepEdges: Edge[];
};

function getLayoutedZapStepsAndEdges(
  nodes: Node<ZapStepNodeData>[],
  edges: Edge[],
  dagreGraph: graphlib.Graph,
) {
  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, {
      width: node.measured?.width,
      height: node.measured?.height,
    });
  });

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  layout(dagreGraph);

  const firstNodeWithPosition = dagreGraph.node(nodes[0].id);

  const layoutedNodes = nodes.map((node) => {
    const nodeWithPosition = dagreGraph.node(node.id);

    // This adjustment horizontally centers the zap steps relative to the zap node above
    const xAdjustment = firstNodeWithPosition.x;

    return {
      ...node,
      targetPosition: Position.Top,
      sourcePosition: Position.Bottom,
      position: {
        x: nodeWithPosition.x - xAdjustment,
        y:
          nodeWithPosition.y -
          (node.measured?.height ?? ZAP_STEP_NODE_HEIGHT) / 2,
      },
    };
  });

  return { nodes: layoutedNodes, edges };
}

export function layoutElementsVertically({
  zapNode,
  zapSteps,
  zapStepEdges,
}: Params) {
  const dagreGraph = new graphlib.Graph();
  dagreGraph.setGraph({ rankdir: "TB" });
  dagreGraph.setDefaultEdgeLabel(() => ({}));

  dagreGraph.setNode(zapNode.id, {
    width: zapNode.measured?.width,
    height: zapNode.measured?.height,
  });

  const { nodes: layoutedZapSteps, edges: layoutedZapStepEdges } =
    getLayoutedZapStepsAndEdges(zapSteps, zapStepEdges, dagreGraph);

  return { layoutedZapSteps, layoutedZapStepEdges };
}
